import React from 'react';

import noSpacesImage from '../../../../static/no-spaces.svg';

import { Container, Title, Text } from './NoSpaces.styled';

const NoSpaces = () => (
  <Container>
    <div>
      <img src={noSpacesImage} alt="No spaces" width={240} height={240} />
    </div>
    <div>
      <Title>Welcome to Aula!</Title>
      <Text>
        You&apos;re all set up! But before you can really get started with Aula,
        admins at your institution will have to add you to your spaces. In the
        meantime, you can connect with others by messaging them on the
        right-hand side.
      </Text>
    </div>
  </Container>
);

export default NoSpaces;
